<template>
  <SubscriptionNavigation :is-loading-data="isGetSubscriptionInProgress">
    <div data-cy="impossible-subscription-page">
      <div class="text-center mb-8">
        <AtomPicto name="clock" size="md" class="mx-auto mb-6" />
        <AtomText
          :text="t('subscription.impossibleToSubscribe.title')"
          font-style="font-semibold"
          font-size="text-xl"
          data-cy="impossible-subscription-title"
        />
        <AtomText
          :text="t('subscription.impossibleToSubscribe.description')"
          color-variant="description"
          class="mt-1 md:px-32"
        />
      </div>

      <div class="flex items-center gap-3">
        <AtomIcon
          icon-name="CalendarIcon"
          icon-type="outline"
          shape-variant="round"
          color-variant="secondary"
          icon-size="md"
          class="shrink-0"
        />
        <div>
          <AtomText
            is-tag="span"
            :text="t('subscription.impossibleToSubscribe.plannedInstallation.label')"
            font-style="font-semibold"
            font-size="text-sm"
            class="mr-1"
          />
          <AtomText
            is-tag="span"
            font-size="text-sm"
            :text="t('subscription.impossibleToSubscribe.plannedInstallation.text')"
          />
        </div>
      </div>

      <AtomDivider class="my-8" />

      <div class="mb-6 flex items-center gap-3">
        <AtomIcon
          icon-name="ExclamationCircleIcon"
          icon-type="outline"
          shape-variant="round"
          color-variant="secondary"
          icon-size="md"
          class="shrink-0"
        />
        <div>
          <AtomText
            is-tag="span"
            :text="t('subscription.impossibleToSubscribe.noEquipment.label')"
            font-style="font-semibold"
            font-size="text-sm"
            class="mr-1"
          />
          <AtomText
            is-tag="span"
            font-size="text-sm"
            :text="t('subscription.impossibleToSubscribe.noEquipment.text')"
          />
        </div>
      </div>

      <div class="grid sm:grid-cols-2 gap-4">
        <MoleculeFrameCard
          spacing="sm"
          mainTheme="dark"
          data-cy="impossible-subscription-virtual-storage-card"
        >
          <AtomPicto name="mySmartBattery" size="sm" />
          <AtomText
            :text="t('subscription.impossibleToSubscribe.virtualStorage.title')"
            font-style="font-bold"
            font-size="text-sm"
            class="mt-2"
          />
          <AtomText
            :text="t('subscription.impossibleToSubscribe.virtualStorage.description')"
            color-variant="description"
            font-size="text-sm"
            class="mt-1"
          />
          <MoleculeStandaloneLink
            :label="t('subscription.impossibleToSubscribe.virtualStorage.link')"
            type="url"
            to="https://www.mylight150.com/stocker"
            target="blank"
            iconName="ExternalLinkIcon"
            color-variant="brand"
            font-size="sm"
            class="mt-4"
          />
        </MoleculeFrameCard>

        <MoleculeFrameCard
          spacing="sm"
          mainTheme="dark"
          data-cy="impossible-subscription-smart-piloting-card"
        >
          <AtomPicto name="mySmartPilot" size="sm" />
          <AtomText
            :text="t('subscription.impossibleToSubscribe.smartPiloting.title')"
            font-style="font-bold"
            font-size="text-sm"
            class="mt-2"
          />
          <AtomText
            :text="t('subscription.impossibleToSubscribe.smartPiloting.description')"
            color-variant="description"
            font-size="text-sm"
            class="mt-1"
          />
          <MoleculeStandaloneLink
            :label="t('subscription.impossibleToSubscribe.smartPiloting.link')"
            type="url"
            to="https://www.mylight150.com/piloter"
            target="blank"
            iconName="ExternalLinkIcon"
            color-variant="brand"
            font-size="sm"
            class="mt-4"
          />
        </MoleculeFrameCard>
      </div>
    </div>
  </SubscriptionNavigation>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { useSubscriptionStore } from '@/stores';

import SubscriptionNavigation from '@/components/SubscriptionNavigation.component.vue';

const { t } = useI18n();
const subscriptionStore = useSubscriptionStore();

const { isGetSubscriptionInProgress } = storeToRefs(subscriptionStore);
</script>

<style scoped></style>
